import {Drawer, Stack, TextField, Typography} from "@mui/material";
import React from "react";
import {useAuthState} from "react-firebase-hooks/auth";
import {auth, formatCurrency, getValidPositiveNumber, isValidPositiveNumber, pri, Pricing, updatePrice} from "../../../firebase/index.js";
import {useInMemoryIndustry} from "../../../redux/InMemoryIndustryReducer.js";
import APXActionButtons from "../../../reusables/APXActionButtons.jsx";
import type {BSLProps} from "../../../reusables/js/APXBottomSheetLayoutUtils.js";
import useBottomSheet from "../../../reusables/js/APXBottomSheetLayoutUtils.js";
import {hideNumberSpinner} from "../../../reusables/js/APXCrucialStyles.js";


export default function AddNewPriceBSL({pp, onClose}: { pp: Pricing } & BSLProps) {
	  
	  const {price, quantity, unit} = (pp: Pricing);
	  
	  const industry = useInMemoryIndustry();
	  const uid = useAuthState(auth)[0]?.uid;
	  
	  const {isOpen, handleClose} = useBottomSheet({initialState: true, onClose});
	  
	  const [disablePositiveByDefault, setDisablePositiveByDefault] = React.useState(true);
	  
	  const [newPrice, setNewPrice] = React.useState(0);
	  
	  React.useEffect(() => {
			 setDisablePositiveByDefault( /*NOT->*/ !isValidPositiveNumber(newPrice));
	  }, [newPrice]);
	  
	  const handleCancel = () => {
			 setNewPrice(0);
			 onClose();
	  };
	  
	  const handleAdd = () => {
			 const newPricing: Pricing = Pricing.fromObject(pp);
			 newPricing.price = newPrice;
			 updatePrice(uid, industry.industryKey, newPricing.getKey(), newPricing.price);
			 handleCancel();
	  };
	  
	  return (
				 <Drawer anchor="bottom" open={isOpen} onClose={handleClose} variant="temporary">
						<Stack spacing={2} p={2}>
							  <Stack direction={{xs: "column", sm: "row"}} spacing={2}>
									 <TextField label={`New ${pri}`} variant="outlined" fullWidth required type="number" InputProps={hideNumberSpinner}
													value={newPrice}
													onChange={(e) => setNewPrice(getValidPositiveNumber(e.target.value))}
									 />
							  </Stack>
							  <Typography variant="body2" color="primary" align={"center"}>
									 {`Current ${pri}: ${formatCurrency(Number(price))} / ${quantity} ${unit}`}
							  </Typography>
							  
							  
							  <APXActionButtons onCancel={handleCancel}
													  onAdd={handleAdd}
													  disablePositiveByDefault={disablePositiveByDefault}
													  shouldShowConfirmationDialog={true}
							  />
						</Stack>
				 </Drawer>
	  );
}
